import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, LogIn, Phone } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import LanguageSwitcher from "./LanguageSwitcher";
import Logo from "./Logo";

export default function Header() {
    const { t } = useLang();
    const [open, setOpen] = useState(false);

    const navLinks = [
        { href: "#services", key: "nav.services" },
        { href: "#prices", key: "nav.pricing" },
        { href: "#offer", key: "nav.offer" },
        { href: "#booking", key: "nav.booking" },
        { href: "#contact", key: "nav.contact" },
    ];

    return (
        <header className="sticky top-0 z-50 glass border-b border-slate-200/60" data-testid="site-header">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12 flex items-center justify-between h-24 lg:h-28 gap-3">
                <Logo asLink size="sm" variant="light" className="shrink-0" />

                <nav className="hidden lg:flex items-center gap-8">
                    {navLinks.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-${l.href.slice(1)}-link`}
                            className="text-sm font-semibold text-[#1A365D]/80 hover:text-[#16A34A] transition-colors"
                        >
                            {t(l.key)}
                        </a>
                    ))}
                </nav>

                <div className="hidden lg:flex items-center gap-3">
                    <LanguageSwitcher />
                    <a
                        href="tel:0786030294"
                        className="hidden xl:inline-flex items-center gap-1.5 text-sm font-semibold text-[#1A365D]"
                        data-testid="header-phone-link"
                    >
                        <Phone className="w-4 h-4" /> 078 603 02 94
                    </a>
                    <Link to="/login" className="btn-secondary" data-testid="header-login-button">
                        <LogIn className="w-4 h-4" /> {t("nav.login")}
                    </Link>
                </div>

                <button
                    className="lg:hidden text-[#1A365D]"
                    onClick={() => setOpen((v) => !v)}
                    aria-label="Menü öffnen"
                    data-testid="mobile-menu-toggle"
                >
                    {open ? <X /> : <Menu />}
                </button>
            </div>
            {open && (
                <div className="lg:hidden border-t border-slate-200 bg-white px-6 py-6 space-y-4" data-testid="mobile-menu">
                    {navLinks.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            onClick={() => setOpen(false)}
                            className="block text-base font-semibold text-[#1A365D]"
                            data-testid={`mobile-nav-${l.href.slice(1)}-link`}
                        >
                            {t(l.key)}
                        </a>
                    ))}
                    <div className="flex items-center justify-between pt-4 border-t border-slate-200">
                        <LanguageSwitcher />
                        <Link
                            to="/login"
                            className="btn-secondary !px-5 !py-2"
                            onClick={() => setOpen(false)}
                            data-testid="mobile-login-button"
                        >
                            {t("nav.login")}
                        </Link>
                    </div>
                </div>
            )}
        </header>
    );
}
